<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <produto-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="loadList"
            :action="produtoAction"
            :produto="produto"
          ></produto-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Produtos Cadastrados</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novoParceiro"
                    >
                      Cadastrar novo Produto
                    </button>
                  </div>
                </template>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaProdutos.columns"
                  :data="tabelaProdutos.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.nome }} kWp</b>
                    </td>
                    <td>{{ row.fornecedor }}</td>
                    <td>
                      <span class="text-capitalize">{{
                        getTecnologia(row.tipoTecnologia)
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="editarProduto(row)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-danger"
                        @click="handleDelete(row)"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaProdutos.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o produto?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deleteProduct()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ProdutoForm from './Forms/ProdutoForm.vue';
import LTable from 'src/components/Table.vue';
import ProdutosServices from 'src/services/produtos';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Nome', 'Fornecedor', 'Tecnologia'];
export default {
  components: {
    ProdutoForm,
    LTable,
    vPagination
  },
  data() {
    return {
      tabelaProdutos: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      produtoAction: '',
      produto: {},
      isDeleteModalVisible: false,
      productToDelete: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ProdutosServices.listar({ page: this.currentPage })
        .then(response => {
          const resultsWithValueAsString = _.get(response, 'data.result').map(
            element => ({
              ...element,
              valor: element.valor.$numberDecimal,
              nome: element.nome.$numberDecimal
            })
          );
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
          this.tabelaProdutos.data = resultsWithValueAsString;
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    novoParceiro() {
      this.produtoAction = 'NEW';
      this.produto = {};
      this.isModalVisible = true;
    },
    editarProduto(produto) {
      this.produtoAction = 'EDIT';
      this.produto = { ...produto };
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getTecnologia(tecnologia) {
      switch (tecnologia) {
        case 'inversor-string':
          return 'Inversor String';
        case 'micro-inversor':
          return 'Microinversor';
        case 'solar-edge':
          return 'SolarEdge';
      }
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.productToDelete = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.productToDelete = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deleteProduct() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.loadList();
        this.closeDeleteModal();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        this.closeDeleteModal();
        loader.hide();
      };

      ProdutosServices.deletar(this.productToDelete)
        .then(sucessCallback)
        .catch(errorCallback);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style scoped>
.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
